import { Component, DestroyRef, inject, Input, type OnChanges } from '@angular/core';
import { FormConfigElement, type PageHierarchyNode } from '@big-direkt/form/contracts';
import { UiAlertComponent } from '@big-direkt/ui/alert';
import { type TypedSimpleChanges } from '@big-direkt/utils/shared';
import { StructureBaseComponent } from '../../../base-components/structure-base/structure-base.component';
import { ElementHostDirective } from '../../../directives/element-host/element-host.directive';
import { StringReplacePipe } from '../../../pipes/string-replace/string-replace.pipe';
import { ComponentService } from '../../../services/component/component.service';
import { ErrorMessageService } from '../../../services/error-message/error-message.service';

@Component({
    selector: 'big-form-page',
    templateUrl: './page.component.html',
    imports: [
        ElementHostDirective,
        StringReplacePipe,
        UiAlertComponent,
    ],
})
export class PageComponent extends StructureBaseComponent implements OnChanges {
    private readonly componentService = inject(ComponentService);
    private readonly errorMessageService = inject(ErrorMessageService);
    public readonly destroyRef = inject(DestroyRef);

    public readonly errorMessages = this.errorMessageService.messages;

    @Input() public declare settings: FormConfigElement;

    public override get isHidden(): boolean {
        if (!this.pageNavigationService.getCurrentPage()) {
            return true;
        }

        return !(
            this.pageNavigationService.getCurrentPage()?.ancestorsAndSelf.some((page: PageHierarchyNode): boolean => page.settings === this.settings) ?? false
        );
    }

    public ngOnChanges(changes: TypedSimpleChanges<PageComponent>): void {
        if (changes.settings?.previousValue) {
            this.componentService.detachViewContainer(this.elementHost?.viewContainerRef);
        }
        if (changes.settings?.currentValue) {
            this.componentService.insertViewChildren(changes.settings.currentValue.children, this.elementHost?.viewContainerRef);
        }
        this.label.set(this.tokenService.findReplacement(this.settings.title ?? '', this.settings.arrayParents));
    }
}
